module.exports = __webpack_public_path__ + "img/ta-ny-leftTitle02eryanghualiu03.0e3ca7c7.png";